import { MARKET_TYPE, SEC_TYPE } from 'const/stock'
import { isNumber } from './common'
import getLocalSymbol from './getLocalSymbol'
import isIndexStock from './isIndexStock'
import getOptionExpiryStamp from './getOptionExpiryStamp'

/**
 * 获取本地修复后的行情信息
 * 1. 计算涨跌额涨跌幅
 * 2. 获取真实的 symbol 以及 webLocal 信息
 * 3. 添加isIndex，tradable，market 等信息
 * 4. 处理盘前盘后信息
 */
export default function getLocalFixedQuoteDetail(detail) {
  if (Array.isArray(detail)) {
    return detail.map(quote => getLocalFixedQuoteDetail(quote))
  }
  if (detail.__quote__) return detail
  detail.__quote__ = true
  setFixedChangeAndRate(detail)
  setFixedHourTrading(detail)
  setFixedLocalSymbol(detail)
  if (detail.secType === SEC_TYPE.OPT) {
    detail.market = detail.market || MARKET_TYPE.US
    detail.isIndex = false
  }
  detail.isIndex = isIndexStock(detail)
  detail.stockId = detail.symbol + '.' + detail.market
  detail.secType = detail.secType || SEC_TYPE.STK
  detail.tradable = !detail.isIndex

  return detail
}

// 设置涨跌额涨跌幅
function setFixedChangeAndRate(detail) {
  if (!detail.latestPrice || !detail.preClose) return
  if (!isNumber(detail.change)) {
    detail.change = (detail.latestPrice || 0) - (detail.preClose || 0)
  }
  if (!isNumber(detail.changeRate)) {
    detail.changeRate = detail.preClose ? detail.change / detail.preClose : 0
  }
}

function setFixedHourTradingChangeAndRate(detail) {
  if (!detail.hourTradingLatestPrice || !detail.hourTradingPreClose) return
  if (!isNumber(detail.hourTradingChange)) {
    detail.hourTradingChange =
      (detail.hourTradingLatestPrice || 0) - (detail.hourTradingPreClose || 0)
  }
  if (!isNumber(detail.hourTradingChangeRate)) {
    detail.hourTradingChangeRate = detail.hourTradingPreClose
      ? detail.hourTradingChange / detail.hourTradingPreClose
      : 0
  }
}

// 设置标的可识别代码
function setFixedLocalSymbol(detail) {
  if (detail.secType === SEC_TYPE.OPT) {
    // 处理 symbol 为 AAPL 20201222 112.0 CALL 这种数据形式的 symbol
    const [symbol, expiry, strike, right] = detail.symbol.split(' ')
    detail.symbol = symbol
    detail.expiry = getOptionExpiryStamp(detail.expiry || expiry)
    detail.strike = detail.strike || strike
    detail.right = detail.right || right
    detail.webLocal = {
      right: detail.right,
      strike: detail.strike,
      expiry: detail.expiry,
      symbol: getLocalSymbol(detail)
    }
  } else {
    detail.webLocal = { symbol: detail.symbol }
  }
}

function setFixedHourTrading(detail) {
  if (typeof detail.hourTrading === 'object') {
    detail.hourTradingLatestPrice = detail.hourTrading.latestPrice
    detail.hourTradingLatestTime = detail.hourTrading.latestTime
    detail.hourTradingVolume = detail.hourTrading.volume
    detail.hourTradingPreClose = detail.hourTrading.preClose
    detail.hourTradingTag = detail.hourTrading.tag
    setFixedHourTradingChangeAndRate(detail)
  }
}
